import { connect } from 'react-redux'
import { CcCartCheckComponent } from './CcCartCheckComponent'
import { Dispatch } from 'redux'
import { push } from 'connected-react-router'
import type { RestaurantShortDTO } from 'shared/types'
import { setCollectMode, setRestaurant } from 'shared/store/ecommerce/order'
import type { RootState } from 'shared/store/reducers'
import {
    fetchRestaurantData,
    isRestaurantAvailable
} from 'shared/store/restaurant'
import { fetchCatalog } from 'shared/store/ecommerce/catalog'

const mapStateToProps = (state: RootState) => {
    const { products, promotions } = state.ecommerceOrderState
    const hasCart = products?.length > 0 || promotions?.length > 0
    const { available: availableFeatures } = state.featuresState
    return {
        hasCart,
        availableFeatures
    }
}

const mapDispatchToProps = (d: Dispatch<any>) => ({
    navigate: (to: string, state?: any) =>
        d(
            push({
                pathname: to,
                state
            })
        ),
    setRestaurant: (restaurant: RestaurantShortDTO) =>
        d(setRestaurant(restaurant)),
    isRestaurantAvailable: (restaurantId: string) =>
        d(isRestaurantAvailable(restaurantId)),
    setCollectMode: (collectMode: string) => d(setCollectMode(collectMode)),
    fetchRestaurantData: (frNumber: string) => d(fetchRestaurantData(frNumber)),
    fetchCatalog: (id: string) => d(fetchCatalog(id))
})

const CcCartCheck = connect(
    mapStateToProps,
    mapDispatchToProps
)(CcCartCheckComponent)
export { CcCartCheck }
